import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiServiceService } from '../service/api-service.service';
import { SharedService } from '../service/shared.service';
import { configuration } from 'src/configuration';
declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {

  fromButtonLogin: boolean = false;
  mortgagesForm: FormGroup;
  documentassistantForm: FormGroup;
  propertyvalueapproximationForm: FormGroup;
  isSubmitted = false;
  isCaptchaResolved = false;
  emirates = configuration.EMIRATES;
  successMessage: string = '';
  errorMessage: string = '';
  message: string = '';
  areaImages : any = []
  _areaImages : any = []
  titleDeedImages : any = []
  _titleDeedImages : any = []
  floorPlanImages : any = []
  _floorPlanImages : any = []
  isApproximationFormSubmit : any =false
  currentId : any;
  isSignupFormOpen = false;
  approximationFormMessage : any = ''

  constructor(
    public shared: SharedService,
    private fb: FormBuilder,
    private router: Router,
    private apiService: ApiServiceService
  ) {
    this.mortgagesForm = this.fb.group({
      name: ['', Validators.required],
      mobile: ['', Validators.required],
      occupation: ['', Validators.required],
      dob: ['', Validators.required],
      emirates: ['', Validators.required],
    });

    this.documentassistantForm = this.fb.group({
      name: ['', Validators.required],
      mobile: ['', Validators.required],
      email: ['', Validators.required],
      assistant_for: ['', Validators.required],
    });

    this.propertyvalueapproximationForm = this.fb.group({
      area: [''],
      title_deed: [''],
      floor_plan: [''],
      description_Views: [''],
      upgradations: [''],
      contact_number: [''],
      owners_name: [''],
      address_of_property: [''],
    });
    this.shared.isWhiteMenu = true;
  }

  openSignUp() {
    setTimeout(() => {
      $('#signupModal').modal('show');
    });
  }

  onSignUpClose() {
    setTimeout(() => {
      $('#signupModal').modal('hide');
    });

  }

  onCaptchaResolved(response: string) {
    console.log('reCAPTCHA response:', response);
    this.isCaptchaResolved = true;
  }

  onSubmit() {
    console.log("on click");
    console.log("this.shared.isUserLoggedIn", this.shared.isUserLoggedIn);

    if (this.shared.isUserLoggedIn) {
      // this.router.navigate(['/create-property']);
      window.location.href = '/create-property'
    } else {
      this.shared.fromButtonLogin = true;
    }
    // console.log("this.fromButtonLogin",this.fromButtonLogin)
  }

  
  
  async onClick() {
    if (this.mortgagesForm.valid) {
      let res: any = await this.apiService.POST_apiRequest(configuration.ENDPOINT.MORTAGAGE_ADD, this.mortgagesForm.value)
      // console.log(res)
      if (res && !res.error) {
        this.isSubmitted = true;
        this.message = 'Our mortgage advisor will get in touch with you soon.';
      } else {
        this.message = 'Error submitting the form. Please try again.';
      }
      console.log(this.message)
    }
  }

  onModalClose() {
    this.isSubmitted = false;
    this.message = '';
    this.mortgagesForm.reset();
  }


  onClear() {
    console.log(this.documentassistantForm.value);

    // Handle document assistant form clearing logic here
  }

  async onDone() {
    let is_error = false;
    // let currentId : any;
    // console.log(this.propertyvalueapproximationForm.value);
    let res =await this.apiService.POST_apiRequest(configuration.ENDPOINT.ADD_PROPERY_VALUE_APPROXIMATION, {
      description: this.propertyvalueapproximationForm.value.description_Views,
      upgradations: this.propertyvalueapproximationForm.value.upgradations,
      contact_number: this.propertyvalueapproximationForm.value.contact_number,
      owner_name: this.propertyvalueapproximationForm.value.owners_name,
      address: this.propertyvalueapproximationForm.value.address_of_property,
    })
    // console.log("res.data.id",res.data.id)
    if(res && !res.error && res.data && res.data.id){
      console.log("inside")
      console.log("res.data.id",res.data.id)
      is_error = false
      this.currentId = res.data.id
    }else{
      is_error = true
    }
    console.log("this.currentId",this.currentId)
    if (this._areaImages && this._areaImages.length > 0) {

      let files = this._areaImages
      const formData = new FormData();
      formData.append("id", this.currentId);
      for (let t of files) {
        formData.append("files", t);
      }
      this.apiService.isUploadImage = true;
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.UPLOAD_PROPERY_VALUE_APPROXIMATION_AREA, formData)
      if(res && !res.error){
        is_error = false
      }else{
        is_error = true
      }
    }

    if (this._titleDeedImages && this._titleDeedImages.length > 0) {

      let files = this._titleDeedImages
      const formData = new FormData();
      formData.append("id", this.currentId);
      for (let t of files) {
        formData.append("files", t);
      }
      this.apiService.isUploadImage = true;
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.UPLOAD_PROPERY_VALUE_APPROXIMATION_TITLE_DEED, formData)
      if(res && !res.error){
        is_error = false
      }else{
        is_error = true
      }
    }

    if (this._floorPlanImages && this._floorPlanImages.length > 0) {

      let files = this._floorPlanImages
      const formData = new FormData();
      formData.append("id", this.currentId);
      for (let t of files) {
        formData.append("files", t);
      }
      this.apiService.isUploadImage = true;
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.UPLOAD_PROPERY_VALUE_APPROXIMATION_FLOOR_PLAN, formData)
      if(res && !res.error){
        is_error = false
      }else{
        is_error = true
      }
    }
    if (!is_error) {
      // cl;ose modal
      this.propertyvalueapproximationForm.reset()
      this.isApproximationFormSubmit = true
    } else {
      this.approximationFormMessage = 'Error submitting the form. Please try again.'
    }
  }

  onPropertyEvaluation() {
    setTimeout(() => {
      $('#evaluationModal').modal('show');
    });
  }

  closeEvaluationModal() {
    this.isApproximationFormSubmit = false
    this.areaImages = []
    this._areaImages = []
    this._floorPlanImages = []
    this.floorPlanImages = []
    this._titleDeedImages = []
    this.titleDeedImages = []
    setTimeout(() => {
      $('#evaluationModal').modal('hide');
    });
  }

  onFileChange(event: any, name: any) {
    if (name === 'area') {
      this._areaImages = [...event.target.files];
      for (let i = 0; i < event.target.files.length; i++) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.areaImages.push(e.target.result);
        };
        reader.readAsDataURL(event.target.files[i]);
      }
    } else if (name === 'title_deed') {
      this._titleDeedImages = [...event.target.files];
      for (let i = 0; i < event.target.files.length; i++) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.titleDeedImages.push(e.target.result);
        };
        reader.readAsDataURL(event.target.files[i]);
      }
    } else if (name === 'floor_plan') {
      this._floorPlanImages = [...event.target.files];
      for (let i = 0; i < event.target.files.length; i++) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.floorPlanImages.push(e.target.result);
        };
        reader.readAsDataURL(event.target.files[i]);
      }
    }
  }

  deleteImage(index:any , name : any){
    if (name === 'area'){
    this.areaImages.splice(index, 1);
    }else if(name === 'title_deed'){
      this.titleDeedImages.splice(index, 1);
    }else if (name === 'floor_plan') {
      this.floorPlanImages.splice(index, 1);
    }
  }



  onClose(e: any) {
    console.log("close calling");
    this.fromButtonLogin = false;
  }

  logout() {
    localStorage.clear();
    window.location.href = '/';
  }

  onOpenModal(name: any) {
    if (name == 'mortgages') {
      setTimeout(() => {
        $('#exampleModalCenter').modal('show');
      });
    }
  }

  onCloseModal(name: any) {
    if (name == 'mortgages') {
      setTimeout(() => {
        this.isSubmitted = false
        this.mortgagesForm.reset()
        $('#exampleModalCenter').modal('hide');
      });
    }
  }
}


// onDone() {
//   if (this.devloperForm.valid) {
//     this.apiService.POST_apiRequest(configuration.ENDPOINT.ASSISTED_PLANS, this.devloperForm.value)
//       .then(res => {
//         if (res && !res.error) {
//           this.isSubmitted = true;
//           this.message = 'Our team will get in touch with you.';
//         } else {
//           console.error("Error submitting the form:", res);
//           this.message = 'Error submitting the form. Please try again.';
//         }
//       })
//       .catch(error => {
//         console.error("An error occurred during form submission:", error);
//         this.message = 'An error occurred during form submission. Please try again.';
//       });
//   }
// }
// onModalClose() {
//   this.isSubmitted = false;
//   this.message = '';
//   this.devloperForm.reset();
// }

// this.devloperForm = this.fb.group({
//   name: ['', Validators.required],
//   email: ['', Validators.required],
//   mobile: ['', Validators.required],
//   project_name: ['', Validators.required],
//   devloper_name: ['', Validators.required],
//   emirates: ['', Validators.required],
// });



// onClick() {
//   if (this.mortgagesForm.valid) {
//     this.apiService.POST_apiRequest(configuration.ENDPOINT.MORTAGAGE_ADD, this.mortgagesForm.value)
//       .then(res => {
//         if (res && !res.error) {
//           this.isSubmitted = true;
//           this.message = 'Our mortgage advisor will get in touch with you soon.';
//         } else {
//           console.error("Error submitting the form:", res);
//           this.message = 'Error submitting the form. Please try again.';
//         }
//       })
//       .catch(error => {
//         console.error("An error occurred during form submission:", error);
//         this.message = 'An error occurred during form submission. Please try again.';
//       });
//   }
// }

// onModalClose() {
//   this.isSubmitted = false;
//   this.message = '';
//   this.mortgagesForm.reset();
// }